import { HvacOffIcon } from './HvacOffIcon';

/**
 * author: Michael Irigoyen
 * id 30019019-F955-40EE-B811-C634718E6FAD
 * name hvac-off
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hvac-off.svg
 * tags
 * - Home Automation 
 */
export const AirConditioningOffIcon = HvacOffIcon;
export default AirConditioningOffIcon